
(function () {
  if (window.URVSlider) return; // guard: file may be included by several section instances
  window.URVSlider = true;
 
  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var instances = {}; // sectionId -> Swiper instance
 
  function num(v, fallback) {
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  }
 
  function bool(v) {
    return v === 'true';
  }
 
  function getConfig(sec) {
    var d = sec.dataset;
    return {
      desk: num(d.slidesDesktop, 4),
      tab: num(d.slidesTablet, 2.2),
      mob: num(d.slidesMobile, 1.6),
      gap: num(d.gap, 32),
      gapMob: num(d.gapMob, 24),
      loop: bool(d.loop),
      autoplay: bool(d.autoplay),
      delay: num(d.autoplaySpeed, 5) * 1000,
      centerMob: bool(d.centerMobile)
    };
  }
 
  /*
    Read more / Read less.
    Open cards are never reset on Swiper "resize" (cards expanding changes height
    and triggers resize) - only closed cards get their button visibility measured.
  */
  function setupReadMore(sec, sid) {
    sec.querySelectorAll('.urv-card').forEach(function (card) {
      var text = card.querySelector('.urv-card__text');
      var btn = card.querySelector('.urv-readmore');
      if (!text || !btn) return;
 
      if (!btn._urv) {
        btn._urv = true;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var open = card.classList.toggle('is-open');
          btn.textContent = open ? btn.dataset.less : btn.dataset.more;
          var sw = instances[sid];
          if (sw && sw.update) {
            requestAnimationFrame(function () { sw.update(); });
          }
        });
      }
 
      if (card.classList.contains('is-open')) {
        btn.hidden = false;
        return;
      }
 
      btn.textContent = btn.dataset.more;
      btn.hidden = !(text.scrollHeight > text.clientHeight + 2);
    });
  }
 
  function destroy(sid) {
    if (instances[sid] && instances[sid].destroy) {
      instances[sid].destroy(true, true);
    }
    delete instances[sid];
  }
 
  function init(sec) {
    var sid = sec.dataset.sectionId;
    var el = sec.querySelector('.urv-swiper');
    if (!sid || !el) return;
 
    destroy(sid);
 
    var CFG = getConfig(sec);
    var opts = {
      speed: 500,
      grabCursor: true,
      watchOverflow: true,
      loop: CFG.loop && el.querySelectorAll('.swiper-slide').length > CFG.desk,
      navigation: {
        prevEl: sec.querySelector('.urv-arrow--prev'),
        nextEl: sec.querySelector('.urv-arrow--next')
      },
      slidesPerView: CFG.mob,
      spaceBetween: CFG.gapMob,
      centeredSlides: CFG.centerMob,
      breakpoints: {
        768: { slidesPerView: CFG.tab, spaceBetween: CFG.gap, centeredSlides: false },
        1024: { slidesPerView: CFG.desk, spaceBetween: CFG.gap, centeredSlides: false }
      },
      on: {
        init: function () { setupReadMore(sec, sid); },
        resize: function () { setupReadMore(sec, sid); }
      }
    };
 
    if (CFG.autoplay) {
      opts.autoplay = { delay: CFG.delay, disableOnInteraction: false, pauseOnMouseEnter: true };
    }
 
    instances[sid] = new Swiper(el, opts);
  }
 
  function loadSwiper(cb) {
    if (window.Swiper) return cb();
 
    var existing = document.querySelector('script[data-urv-swiper]');
    if (existing) {
      existing.addEventListener('load', cb);
      return;
    }
 
    var sc = document.createElement('script');
    sc.src = SWIPER_JS;
    sc.setAttribute('data-urv-swiper', '');
    sc.onload = cb;
    document.head.appendChild(sc);
  }
 
  function initAll(root) {
    var list = (root || document).querySelectorAll('.urv[data-urv]');
    if (!list.length) return;
    loadSwiper(function () {
      list.forEach(init);
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
 
  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
 
  document.addEventListener('shopify:section:unload', function (e) {
    var sec = e.target.querySelector('.urv[data-urv]');
    if (sec) destroy(sec.dataset.sectionId);
  });
})();

document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');
    
    if (!doubleuspsElement) {
      console.error('Error: .doubleusps element not found');
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;
    
    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});